import * as angular from "angular";
import template from "./entity-contacts-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import type {
	EntityModel,
	EntityOperation,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityContactsTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	put: EntityOperation;
	post: EntityOperation;
}

// eslint-disable-next-line no-redeclare
export class EntityContactsTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canViewContacts = globs.entityTypes.byType(this.typeConfig.Code).contacts.byCode("*").read;
		this.tab = {
			name: "Contacts",
			code: "CONTACTS",
			isAvailable: !!(
				this.securityService.isActionOrPatternAllowed(canViewContacts)
				&& isSupportedOrNullish(this.typeConfig.Contacts)
			)
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-contacts-tab", [])
	.component("entityContactsTab", {
		controller: EntityContactsTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			put: "=",
			post: "="
		}
	})
	.name;
